import React, { ReactNode } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import LinkWrapper from 'components_new/atoms/LinkWrapper'

export interface KanbanCardProps {
  children: ReactNode
  // When true the card cannot be dragged (read-only board).
  disabled?: boolean
  disablePadding?: boolean
  href?: string
  id: string
  onClick?: () => void
  sx?: SxProps
}

const KanbanCard = (props: KanbanCardProps) => {
  const { children, disabled, disablePadding, href, id, onClick, sx } = props

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id, disabled })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  const dragHandleProps = disabled ? {} : { ...attributes, ...listeners }

  return (
    <LinkWrapper href={href} style={{ width: '100%', display: 'block' }}>
      <Box
        onClick={onClick}
        ref={setNodeRef}
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          cursor: onClick || href ? 'pointer' : disabled ? 'default' : 'grab',
          mb: 1.5,
          p: disablePadding ? undefined : 2,
          '&:hover': {
            borderColor: 'primary.main',
            ['& .OptionsMenuButton']: {
              opacity: 1
            },
            ['& .EditTitleButton']: {
              opacity: 1
            }
          },
          ...style,
          ...sx
        }}
        {...dragHandleProps}
      >
        {children}
      </Box>
    </LinkWrapper>
  )
}

export default KanbanCard
